<template>
  <v-footer
    v-if="!disabled"
    :color="this.$vuetify.theme.isDark ? 'dark' : 'white'"
    height="38"
    padless
  >
    <v-col class="text-center pa-2 pl-0" cols="12">
      <vac
        ref="vac"
        :end-time="new Date().getTime() + seconds * 1000"
        @finish="onfinish"
        @process="onProcess"
        class="d-flex align-center justify-between flex-nowrap"
      >
        <template v-slot:process="{ timeObj }">
          <span style="min-width: 90px">
            <v-icon> alarm </v-icon>
            {{ timeObj.h !== "00" ? `${timeObj.h}:` : ""
            }}{{ `${timeObj.m}:${timeObj.s}` }}
          </span>
        </template>
        <template v-slot:finish>
          <span>
            <v-icon> alarm_off </v-icon>
            Tempo esgotado!
          </span>
        </template>
      </vac>
    </v-col>
    <v-col class="pt-0" cols="12">
      <v-progress-linear
        v-if="showProgressBar"
        :value="this.progress"
        color="primary"
        height="4"
        rounded
      ></v-progress-linear>
    </v-col>
  </v-footer>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      dialog: true,
      progress: 0,
      showProgressBar: true,
      totalSeconds: 1,
    };
  },
  computed: {},
  props: {
    seconds: {
      type: Number,
      default: 45 * 1000,
    },
    disabled: {
      default: true,
      type: Boolean,
      required: false,
    },
  },
  created() {
    this.totalSeconds = this.seconds;
  },
  methods: {
    onProcess() {
      // console.log(this.$refs.vac.timeObj)
      const t = this.$refs.vac.timeObj;
      this.progress = (t.ceil.s / this.totalSeconds) * 100;
      // console.log(t.ceil.s, this.totalSeconds ,this.progress)
      this.$emit("timeUpdate", Math.round(t.ceil.s));
      // console.log(this.$attrs.value)
    },
    onfinish() {
      this.showProgressBar = false;
      this.$emit("timeOver");
    },
  },
};
</script>

<style scoped>
.dark {
  background-color: transparent !important;
  color: #fff !important;
}
</style>
